import React, { useState } from 'react';
import { CourseType, CourseTitle, LabelMedium } from './Typography';
import hexagonImage from '../images/hexagon_white.png';
import hexagonBorderImage from '../images/hexagon_white_border.png';

const CourseCard = ({ course, onClick, progressData }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Determine course status and CTA text
  const getCourseStatus = () => {
    if (!progressData) return 'not_started';
    if (progressData.hasActive) return 'in_progress';
    if (progressData.completed === progressData.total && progressData.total > 0) return 'completed';
    return 'not_started';
  };

  const getCTAText = () => {
    const status = getCourseStatus();
    switch (status) {
      case 'completed':
        return 'Review Course →';
      case 'in_progress':
        return 'Jump Back In →';
      default:
        return 'Get Started →';
    }
  };

  const courseStatus = getCourseStatus();
  const ctaText = getCTAText();
  const progressPercentage = progressData?.progress || 0;

  return (
    <button
      type="button"
      className="relative w-[360px] h-[288px] cursor-pointer transform hover:scale-105 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-[#0A4872] focus:ring-offset-2 rounded-sm"
      onClick={() => onClick && onClick(course)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={`${course.title}: ${ctaText}`}
    >
      {/* Hexagon background is decorative; card button label conveys the content */}
      <div className="absolute inset-0">
        <img 
          src={isHovered ? hexagonBorderImage : hexagonImage} 
          alt=""
          role="presentation"
          className="w-full h-full object-contain"
        />
      </div>

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-8">
        {/* Status Badge - Only show if completed */}
        {courseStatus === 'completed' && (
          <div className="mb-2 px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
            ✓ Completed
          </div>
        )}

        {/* Course Type */}
        <div className="mb-2">
          <CourseType className="!text-[#091E42]">
            {course.type || 'HOW TO WRITE A'}
          </CourseType>
        </div>

        {/* Course Title */}
        <div className="mb-4 px-2">
          <CourseTitle className="leading-[1em] !text-[#091E42]">
            {course.title}
          </CourseTitle>
        </div>

        {/* Progress Bar - Only show if there's progress */}
        {progressData && (progressData.completed > 0 || progressData.hasActive) && (
          <div
            role="progressbar"
            aria-valuenow={progressPercentage}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={`Course progress: ${progressPercentage}%`}
            className="mb-4 w-20 h-[15px] bg-gray-300 rounded-full overflow-hidden"
          >
            <div 
              className="h-full transition-all duration-300" 
              style={{ width: `${progressPercentage}%`, backgroundColor: '#0A4872' }} 
            />
          </div>
        )}

        {/* Call to Action */}
        <div>
          <LabelMedium className="!text-[#091E42]">
            {getCTAText()}
          </LabelMedium>
        </div>
      </div>
    </button>
  );
};

export default CourseCard;
